import { styled } from "@mui/material/styles";
import Switch, { SwitchProps } from "@mui/material/Switch";

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 46,
  height: 25,
  padding: 0,
  // Styles for the switch base (the clickable part)
  "& .MuiSwitch-switchBase": {
    paddingTop: "1px",
    paddingLeft: "1px",
    margin: 2,
    transitionDuration: "300ms",
    // Styles when the switch is checked (on)
    "&.Mui-checked": {
      transform: "translateX(19.5px)",
      // Styles for the track when the switch is checked
      "& + .MuiSwitch-track": {
        backgroundColor: "#93C5FD",
        opacity: 1,
      },
      // Styles when the switch is disabled and checked
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    // Styles when the switch is focused
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#93C5FD",
      border: "6px solid #fff",
    },
    // Styles when the switch is disabled
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
    },
  },
  "& .MuiSwitch-switchBase:hover": {
    backgroundColor: "transparent",
  },
  "& .MuiSwitch-switchBase:hover .MuiSwitch-track": {
    backgroundColor: "transparent",
    boxShadow: "none",
  },
  // The actual switch circle
  "& .MuiSwitch-thumb": {
    width: 19,
    height: 19,
    color: "#fff",
    transform: "translateX(1px)",
    boxShadow: "none",
  },
  // The background track that is pill shaped
  "& .MuiSwitch-track": {
    borderRadius: 13,
    backgroundColor: "#CAD5E2",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

export default IOSSwitch;
